import { mediaItems } from '@/mocks/homeMocks';

export default function MediaSection() {
  return (
    <section id="media" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2 scroll-mt-20">
            精彩看点
          </h2>
          <p className="text-sm text-foreground-600 mb-6">
            漫画PV、创作访谈、活动回顾等精彩内容
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {mediaItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 cursor-pointer"
              >
                <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-foreground-950/20 group-hover:bg-foreground-950/30 transition-colors flex items-center justify-center">
                    <div className="w-12 h-12 bg-background-50/90 rounded-full flex items-center justify-center">
                      <i className="ri-play-fill text-xl text-primary-500 ml-0.5"></i>
                    </div>
                  </div>
                  <div className="absolute bottom-2 right-2">
                    <span className="px-2 py-0.5 bg-foreground-950/70 text-background-50 text-xs rounded whitespace-nowrap">
                      {item.views}次播放
                    </span>
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="text-sm text-foreground-950 line-clamp-2 mb-1">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500">{item.category}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}